import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import { Box, Button, IconButton, Snackbar } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const CookieNotice = () => {
  const user = useSelector(state => state.user)
  const [accepted, setAccepted] = useState(() => Boolean(Cookies.get('cookie-consent')))
  const awaitingAuthenticatedUser = Boolean(Cookies.get('access_token')) && user.isFetching
  const open = !accepted && !user.details && !awaitingAuthenticatedUser

  const accept = () => {
    Cookies.set('cookie-consent', '1', { expires: 365 })
    setAccepted(true)
  }

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      sx={{ '& .MuiSnackbarContent-root': { maxWidth: 600, flexWrap: 'wrap' } }}
      message={
        <Box pr={3}>
          HiddenUnderGround uses cookies on the website for marketing purposes. They help us understand how you use our website, personalize content, and improve your online experience. By clicking Accept, you agree that we and our partners may store and access cookies on your device for these purposes. California law considers some of these activities to be a sale of personal data. If you would like to learn more about how we handle your personal information, click here to review our privacy policy.
        </Box>
      }
      action={
        <>
          <IconButton
            aria-label="Close cookie notice"
            color="inherit"
            size="small"
            onClick={accept}
            sx={{ position: 'absolute', top: 4, right: 4 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <Button color="secondary" size="small" variant="contained" onClick={accept}>
            Accept
          </Button>
          <Button color="secondary" size="small" component={Link} to="/privacy">
            Learn more
          </Button>
        </>
      }
    />
  )
}

export default CookieNotice
